import { useEffect, useState } from 'react';
import React from 'react';
import { OggFieldService } from '../services/ogg.service';
import Loading from './Loading';
import ActionPresentation, { IActionPresentationProps } from './ActionPresentation';
import { StreamingSession } from '../services/streamingSession.service';
import Error, { IWebAppErrorContext } from './Error';
import { error } from 'console';

export interface IActionParentProps {
  streamingSession: StreamingSession;
  oggService: OggFieldService;
}

export interface ICustomActionPresentationProps {
  onStart: () => void;
  presentation: JSX.Element;
}

export interface IActionProps {
  streamOutput: IStreamProps;
  presentation: IActionPresentationProps;
}

export interface IStreamProps {
  streamingContent: string;
  streamingSession: StreamingSession;
  loadingTitle: string;
  loadingSubtitle: string;
  render: (streamingContent: string) => JSX.Element;
}

export default function Action(props: IActionProps) {
  console.debug('loading component Action');
  const [actionStarted, setActionStarted] = useState(false);
  const [errorMessage, setErrorMessage] = useState<IWebAppErrorContext>(null);

  useEffect(() => {
    props.streamOutput.streamingSession.registerOnErrorListener(setErrorMessage);

    return () => {
      props.streamOutput.streamingSession.unregisterOnErrorListener(setErrorMessage);
    };
  }, [props.streamOutput.streamingSession]);

  if (!!errorMessage) {
    return <Error {...errorMessage} />;
  }

  if (!actionStarted && !props.streamOutput.streamingContent)
    return (
      <div className='centered-zero-data'>
        <ActionPresentation
          {...props.presentation}
          onStart={() => {
            setActionStarted(true);
            props.presentation.onStart();
          }}
        ></ActionPresentation>
      </div>
    );

  if (!props.streamOutput.streamingContent) {
    return (
      <div className='centered-zero-data'>
        <div>
          <Loading
            title={props.streamOutput.loadingTitle}
            subtitle={props.streamOutput.loadingSubtitle}
          />
        </div>
      </div>
    );
  }

  if (!!props.streamOutput.streamingContent)
    return (
      <div>
        <div className='streaming-container'>
          {props.streamOutput.render(props.streamOutput.streamingContent)}
        </div>
      </div>
    );
}
